export default __webpack_public_path__ + "67e01fbbd4b4355d3d955cd80065fd77.svg";